app.controller('changePasswordCtrl', function ($scope, $routeParams, $rootScope, uibDateParser, $uibModal, $http, $window, $location, $timeout, Upload, $q, $translate) {

    $scope.User = {};

    $scope.User.GeneratedKey = $routeParams.ResetPasswordKey;

    $scope.working = false;
    $scope.loadMessage = 'Loading...';

    $scope.modalMessage = {
        message: '',
        param: {}
    };
    $scope.ConfirmPassword = '';

    $scope.checkPassword = function () {
        if ($scope.ConfirmPassword != $scope.User.NewPassword) {
            $scope.myForm.txtConfirmPassword.$invalid = true;
        }
    };


    var allPromise = $q.all([
      $http({
          method: 'GET',
          url: '/service/client.svc/GetChangePasswordKey?key=' + $scope.User.GeneratedKey,
      }).then(function (data) {

          if (data.data.d.result) {
              $scope.User.Email = data.data.d.Email;
          }
          else {
              $window.location.href = "#/login";
          }
      }, function (error) { }),
    ]);

    $scope.submit = function () {
        $translate('VALIDATE.confirmation').then(function (strText) {
            $rootScope.AlertYesNo('question', 'Konfirmasi', strText)
            .then((result) => {
                if (result.value) {
                    $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
                    $http({
                        method: 'POST',
                        url: '/service/client.svc/changePassword',
                        data: {
                            User: $scope.User
                        }
                    }).then(function (data) {

                        if (data.data.d.result) {
                            swal('Change Password Success', data.data.d.message, 'success').then(function () {
                                $window.location.href = "#/login/";
                                $window.location.reload();
                            });
                        }
                        else {
                            swal('Failed', data.data.d.message, 'info');
                        }
                    }, function (error) { });
                }
            });
        });
    }
});